module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bV4uJO/tc-custom/9781607053590.jpg?1729082793392",
      "alt": "This image is the cover for the book Elegant Stitches"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Elegant Stitches\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The renowned fiber artist shares a wealth of inspiration in this illustrated reference guide with 100s of stitches for needleworkers of all skill levels.")]), _c('br'), _c('br'), _vm._v("Judith Baker Montano’s "), _c('i', [_vm._v("Elegant Stitches")]), _vm._v(" features all the step-by-step instructions and illustrations you’ll need to create your own embroidered masterpieces. This volume includes 117 embroidery stitches and more than 130 crazy quilt combination stitches to start your stitching adventure. Judith also offers in-depth instruction on silk ribbon stitches, free-form stitches, composite stitches, and even left-handed stitches.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Judith Baker Montano\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Judith Baker Montano Bio:  Judith Baker Montano is a world-renowned author, designer, fiber artist, teacher, and lecturer. Judith resides in Colorado. "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0